import { render } from "./Processed.vue?vue&type=template&id=7513963e"
import script from "./Processed.vue?vue&type=script&lang=js"
export * from "./Processed.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marianne/DevProjects/Marinka backup 29-08-2025/full website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__